(function () {
  if (!window.hasTradePricing) return;

  function resolveTradeId(idInput) {
    if (idInput.dataset.tradeVariantId) return idInput.dataset.tradeVariantId;
    const container = idInput.closest('[data-section], product-form, quick-add-modal, .card-product');
    const jsonEl = container && container.querySelector('script[type="application/json"][data-product-info]');
    if (!jsonEl) return null;
    try {
      const data = JSON.parse(jsonEl.textContent);
      const variant = (data.variants || []).find(v => String(v.id) === String(idInput.value));
      return variant && variant.trade_variant_id ? variant.trade_variant_id : null;
    } catch (e) {
      return null;
    }
  }

  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    const idInput = form.querySelector('[name="id"]');
    if (!idInput) return;
    const tradeId = resolveTradeId(idInput);
    if (tradeId) idInput.value = tradeId;
  }, true);

  const origFetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : input && input.url;
    if (url && url.indexOf('/cart/add') !== -1 && init && init.body instanceof FormData) {
      const idVal = init.body.get('id');
      const el = document.querySelector('[name="id"][value="' + idVal + '"]');
      const tradeId = el ? resolveTradeId(el) : null;
      if (tradeId) init.body.set('id', tradeId);
    }
    return origFetch.apply(this, arguments);
  };
})();